import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { CookiesProvider } from "react-cookie";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import AuthProvider from "./auth/auth.provider";
import DialogsProvider from "./common/dialogs.provider";
import "./common/shims/requestIdleCallback";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import SessionDataProvider from "./user/sessionData.provider";
import UserThemeProvider from "./user/userTheme.provider";
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister'

const container = document.getElementById("root");
const root = createRoot(container);
const queryClient = new QueryClient();

const persister = createAsyncStoragePersister({
	storage: window.localStorage,
});


root.render(
	// <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
	<QueryClientProvider client={queryClient}>
		<CookiesProvider defaultSetOptions={{ path: '/' }}>
			<AuthProvider>
				<UserThemeProvider>
					<SessionDataProvider>
						<LocalizationProvider dateAdapter={AdapterMoment}>
							<BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
								<DndProvider backend={HTML5Backend}>
									<DialogsProvider>
										<App />
									</DialogsProvider>
								</DndProvider>
							</BrowserRouter>
						</LocalizationProvider>
					</SessionDataProvider>
				</UserThemeProvider>
			</AuthProvider>
		</CookiesProvider>
	</QueryClientProvider>
	// </PersistQueryClientProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
